import { faFilter, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { FormProvider, useForm } from "react-hook-form";
import StickyToolbar from "../../../../../Components/StickyToolbar";
import UnForm from "../../../../../Components/Form";
import moment from "moment";

const filtroInicial = {
    DT_INICIO: moment().format("YYYY-MM-DD"),
    DT_FIM: moment().format("YYYY-MM-DD"),
    FILTRO: "",
};

interface IFiltroAtividadesResumo {
    filter:
        | {
              DT_INICIO: string;
              DT_FIM: string;
              FILTRO: string;
          }
        | undefined;
    handleFilter(formData: any): void;
}
export default function FiltroAtividadesResumo(props: IFiltroAtividadesResumo) {
    const FormMethods = useForm();
    const { reset } = FormMethods;

    return (
        <>
            <StickyToolbar>
                <FormProvider {...FormMethods}>
                    <UnForm handleSubmit={props.handleFilter} usingContext>
                        <div className="col-12 mt-3">
                            <label>Data Inicio</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_INICIO"
                                defaultValue={props.filter?.DT_INICIO}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Data Final</label>

                            <UnForm.Input
                                className="form-control"
                                type="date"
                                name="DT_FIM"
                                defaultValue={props.filter?.DT_FIM}
                            />
                        </div>
                        <div className="col-12 mt-3">
                            <label>Categoria</label>

                            <UnForm.Select
                                className="form-control"
                                name="FILTRO"
                                defaultValue={props.filter?.FILTRO}
                            >
                                <option></option>
                                <option value={"Planejadas"}>Planejadas</option>
                                <option value={"Executadas"}>Executadas</option>
                                <option value={"Atrasadas"}>Atrasadas</option>
                                <option value={"Para o Dia"}>Para o Dia</option>
                            </UnForm.Select>
                        </div>

                        <div className="col-12 col-md-12 d-flex align-items-end justify-content-start mt-3">
                            <button
                                type="submit"
                                className="btn btn-block btn-outline-dark"
                            >
                                <FontAwesomeIcon
                                    icon={faFilter}
                                    className="mr-2"
                                />
                                Filtrar
                            </button>
                        </div>
                        <div className="col-12 d-flex align-items-end justify-content-start">
                            <button
                                type="button"
                                onClick={() => {
                                    reset(filtroInicial);
                                }}
                                className="btn btn-block btn-outline-danger mt-2"
                            >
                                <FontAwesomeIcon
                                    icon={faTimes}
                                    className="mr-2"
                                />
                                Limpar Filtros
                            </button>
                        </div>
                    </UnForm>
                </FormProvider>
            </StickyToolbar>
        </>
    );
}
